import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'nwx-outage-banner',
    templateUrl: './outage-banner.component.html',
    styleUrl: './outage-banner.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OutageBannerComponent {
  @Input() outageMessage!: string;
}
